import { useQuery, useMutation } from "convex/react";
import { useSessionMutation, useSessionQuery } from './useSession';
import { api } from "../convex/_generated/api";
import { Id } from "../convex/_generated/dataModel";

/**
 * Plant Lists Hook - Convex Edition
 *
 * Custom hook a növénylisták kezeléséhez Convex-szel.
 */

export const usePlantLists = (userId: Id<"users"> | null): { plantLists: any[] | undefined; isLoading: boolean; createPlantList: any; updatePlantList: any; removePlantList: any; addItem: any; removeItem: any } => {
  // Query user összes listája
  const plantLists = useSessionQuery(
    api.plantLists.list,
    userId ? {} : "skip"
  );

  // Mutations
  const createPlantList = useSessionMutation(api.plantLists.create);
  const updatePlantList = useSessionMutation(api.plantLists.update);
  const removePlantList = useSessionMutation(api.plantLists.remove);
  const addItem = useSessionMutation(api.plantLists.addItem);
  const removeItem = useSessionMutation(api.plantLists.removeItem);

  return {
    // Data
    plantLists,
    isLoading: plantLists === undefined,

    // Mutations
    createPlantList,
    updatePlantList,
    removePlantList,
    addItem,
    removeItem,
  };
};

export const usePlantList = (listId: Id<"plantLists"> | null) => {
  // Query egy konkrét lista lekérésére
  const plantList = useSessionQuery(
    api.plantLists.get,
    listId ? { listId } : "skip"
  );

  // Mutations
  const updatePlantList = useSessionMutation(api.plantLists.update);
  const removePlantList = useSessionMutation(api.plantLists.remove);
  const addItem = useSessionMutation(api.plantLists.addItem);
  const removeItem = useSessionMutation(api.plantLists.removeItem);

  return {
    // Data
    plantList,
    isLoading: plantList === undefined,

    // Mutations
    updatePlantList,
    removePlantList,
    addItem,
    removeItem,
  };
};

export const usePlantListsByGarden = (gardenId: Id<"gardens"> | null) => {
  // Query kerthez tartozó listák
  const plantLists = useSessionQuery(
    api.plantLists.getByGarden,
    gardenId ? { gardenId } : "skip"
  );

  return {
    plantLists,
    isLoading: plantLists === undefined,
  };
};

export const usePlantListCount = (userId: Id<"users"> | null) => {
  // Listák száma
  const count = useSessionQuery(
    api.plantLists.getCount,
    userId ? {} : "skip"
  );

  return {
    count,
    isLoading: count === undefined,
  };
};
